// extracted by mini-css-extract-plugin
module.exports = {"feedbackPopver":"feedback_feedbackPopver__3ki06","feedbackDiv":"feedback_feedbackDiv__1TclX"};